import {inlineError} from '@s-ui/decorators'
import {Service} from '@s-ui/domain'

/**
 * @implements Service
 */
export class GetSubscriptionSearchResultsAdsService extends Service {
  /**
   * @constructor
   * @param {Object} deps
   * @param {HTTPAdsRepository} deps.httpAdsRepository
   */
  constructor({httpAdsRepository}) {
    super()
    this._httpAdsRepository = httpAdsRepository
  }

  @inlineError
  async execute({searchRequestValueObject, withAggregations = true}) {
    const [getSubscriptionSearchResultsError, getSubscriptionSearchResultsResponse] =
      await this._httpAdsRepository.getSearchResults({
        searchRequestObjectValueObject: searchRequestValueObject,
        withAggregations
      })

    return getSubscriptionSearchResultsError
      ? Promise.reject(getSubscriptionSearchResultsError)
      : getSubscriptionSearchResultsResponse
  }
}
